import React, { useState, useEffect } from "react";
import InvoiceHeader from "./InvoiceHeader/InvoiceHeader";
import InvoiceListItem from "../../../components/InvoiceListItem/InvoiceListItems";
import ErrorFooter from "../../../components/ErrorFooter/ErrorFooter";
import "../../../components/ErrorFooter/ErrorFooter.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MdArrowDropDownCircle } from "react-icons/md";
import LoadingOverlay from "react-loading-overlay";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as locationActions from "../../../store/actions/location";
import * as invoiceActions from "../../../store/actions/invoice";

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";
const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const emptyState = (
  <div className="bg-gray-300 lg:py-16 lg:px-24 md:py-8 md:px-12 p-6 space-y-8 rounded w-full">
    <div>
      <svg
        width="60"
        height="60"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.9994 66.667C25.2994 66.667 13.3327 54.7003 13.3327 40.0003C13.3327 25.3003 25.2994 13.3337 39.9994 13.3337C54.6994 13.3337 66.666 25.3003 66.666 40.0003C66.666 54.7003 54.6994 66.667 39.9994 66.667ZM39.9994 73.3337C58.3994 73.3337 73.3327 58.4003 73.3327 40.0003C73.3327 21.6003 58.3994 6.66699 39.9994 6.66699C21.5993 6.66699 6.66602 21.6003 6.66602 40.0003C6.66602 58.4003 21.5993 73.3337 39.9994 73.3337ZM36.666 40.0003V53.3337H43.3327V40.0003H53.3327L39.9994 26.667L26.666 40.0003H36.666Z"
          fill="black"
        />
      </svg>
    </div>
    <div className="">
      <h1 className="font-medium sm:text-xl text-4xl md:text-4xl lg:text-6xl">
        Looks kinda empty <br /> doesn't it?
      </h1>
    </div>
    <div>
      <h4 className="lg:text-xl md:text-lg text-base leading-6">
        Select <b>Month, Year & Centre</b> from the input above to show all
        invoices from that month
      </h4>
    </div>
  </div>
);
// const val = {
//   invoiceUrl:
//     "https://2gethrteam.s3.ap-south-1.amazonaws.com/invoice/invoice-1595513042368.pdf",
//   membershipName: "Optimus Prime Research LLP",
//   organisationName: "Optimus Prime Research LLP",
//   TotalPayable: 59593,
//   invoice_Date: "Jul 2020",
//   itemDescription: "Dedicated Desk ,10Units",
// };

// const adhoc = new Array(10).fill(val);
// const membership = new Array(10).fill(val);

const InvoiceDashboard = (props) => {
  const [month, setMonth] = useState("");
  const [location, setLocation] = useState("");

  const {
    error,
    getInvoices,
    locations,
    getLocations,
    invoices,
    adhoc,
    membership,
    loadingInvoices,
    loadingLocations,
    invoiceError,
    locationError,
  } = props;

  useEffect(() => {
    getLocations();
  }, [getLocations]);

  useEffect(() => {
    if (month && location) {
      getInvoices({ date: month, buildingId: location });
    }
  }, [month, location, getInvoices]);
  return (
    <LoadingOverlay
      active={loadingLocations}
      spinner={loadingLocations}
      // className="h-screen"
    >
      <div className="py-8 lg:px-16 px-8 flex flex-col flex-1 bg-formBackground mb-16">
        <InvoiceHeader />

        {/* Filters */}

        <div className="mt-12">
          <span className="text-base leading-5 text-gray-500">
            Show Invoices For
          </span>
          {/* Filter Inputs */}
          <div className="mt-3">
            <div className="md:flex md:space-x-8">
              <div className="md:w-1/2 w-full mb-6">
                <label className={labelClass} htmlFor="invoice-month">
                  Invoice Month, Year
                </label>

                <input
                  // style={{ padding: 0, margin: 0 }}
                  className={inputClass}
                  id="invoice-month"
                  placeholder="Invoice Month"
                  type="month"
                  name="invoice_month"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                />
              </div>
              <div className="md:w-1/2 w-full mb-6">
                <label
                  className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                  htmlFor="center-location"
                >
                  Center Location
                </label>

                <Autocomplete
                  options={locations || []}
                  getOptionLabel={(option) => option.name}
                  onChange={(_, data) => setLocation(data._id)}
                  renderInput={(props) => (
                    <div
                      className="flex items-center"
                      ref={props.InputProps.ref}
                    >
                      <div className="w-full">
                        <input
                          style={{
                            width: "100%",
                            padding: "10px",
                            borderRadius: "4px",
                            borderColor: "#cbd5e0",
                            border: "1px solid #cbd5e0",
                            outline: "none",
                          }}
                          type="text"
                          placeholder="Select a Center"
                          {...props.inputProps}
                        />
                      </div>
                      <div className="-ml-8">
                        <MdArrowDropDownCircle />
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          <hr className="mb-8 border b-2" />
          {loadingInvoices ? (
            <div className="flex items-center space-x-4">
              <CircularProgress color="inherit" />
              <h3>Getting Invoices</h3>
            </div>
          ) : adhoc &&
            adhoc.length === 0 &&
            membership &&
            membership.length === 0 ? (
            emptyState
          ) : (
            // List Invoices
            <>
              <div className="-mx-6">
                <div className="bg-buttonYellow inline-block py-2 px-4">
                  <span className="text-center text-base leading-5">Adhoc</span>
                </div>
                {adhoc.map((invoice, index) => (
                  <InvoiceListItem key={index} invoice={invoice} />
                ))}
              </div>
              <div className="mt-8 -mx-6">
                <div className="bg-buttonYellow inline-block py-2 px-4">
                  <span className="text-center text-base leading-5">
                    Membership
                  </span>
                </div>
                {membership.map((invoice, index) => (
                  <InvoiceListItem key={index} invoice={invoice} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      {(invoiceError || locationError) && (
        <div className="error-footer">
          <ErrorFooter message={locationError || invoiceError} />
        </div>
      )}
    </LoadingOverlay>
  );
};

const mapStateToProps = (state) => ({
  locations: state.location.locations,
  adhoc: state.invoice.adhoc,
  membership: state.invoice.membership,
  locationError: state.location.error,
  loadingLocations: state.location.loading,
  invoiceError: state.invoice.error,
  loadingInvoices: state.invoice.loading,
});

const mapDispatchToProps = (dispatch) => {
  const getInvoices = invoiceActions.invoice.request;
  const getLocations = locationActions.location.request;
  return bindActionCreators({ getInvoices, getLocations }, dispatch);
};

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(InvoiceDashboard)
);
